import React from 'react';
import type { SVGDefaultProps } from './types';
import { colors } from '@/styles';

export const LFClick = ({ size = 14, title = 'Click', fill = colors.bluebee }: SVGDefaultProps) => {
  const height = Number(size) * 2.85;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 11.25 14.84">
      {Boolean(title) && <title>{title}</title>}
      <g>
        <path
          fill={fill}
          d="M4.16 10.81L3 11.1l-1.2.3a.27.27 0 01-.33-.09.29.29 0 010-.33l2.65-3.93L5.55 5c.1-.15.22-.15.32 0L8 8.09l1.9 2.76a.26.26 0 010 .33.27.27 0 01-.33.1l-2.2-.47H7.2v3.54c0 .34-.14.49-.49.49H4.59c-.33 0-.48-.14-.48-.47v-3.38a1.09 1.09 0 01.05-.18z"
        />
      </g>
      <g>
        <path
          fill={fill}
          d="M4.51 3.5A.58.58 0 014 3.18L2.83.92A.6.6 0 013 .09a.61.61 0 01.83.19l.05.1L5 2.64a.6.6 0 01-.26.8.63.63 0 01-.23.06z"
        />
      </g>
      <g>
        <path
          fill={fill}
          d="M3 5.66a.64.64 0 01-.2 0L.46 4.83a.6.6 0 01.28-1.17h.11l2.33.8a.6.6 0 01.35.77.6.6 0 01-.53.43z"
        />
      </g>
      <g>
        <path
          fill={fill}
          d="M6.87 3.5a.6.6 0 01-.6-.6.59.59 0 01.07-.26L7.48.38A.6.6 0 018.6.82a.31.31 0 010 .1L7.4 3.18a.59.59 0 01-.53.32z"
        />
      </g>
      <g>
        <path
          fill={fill}
          d="M8.39 5.66a.6.6 0 01-.59-.61.58.58 0 01.39-.55l2.32-.8a.6.6 0 01.73.44.62.62 0 01-.34.69l-2.32.8a.58.58 0 01-.19.03z"
        />
      </g>
    </svg>
  );
};
